<template>
  <div id="colorparams">
    <ImageApp />
    <ControlApp />
  </div>
</template>
<script>
import ImageApp from '@/components/ImageApp'
import ControlApp from '@/components/ControlApp'
export default {
  name: 'colorparams',
  components: {
    ImageApp,
    ControlApp
  }
}
</script>
<style lang="scss">
body{
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  overflow-x: hidden;
}
#colorparams{
  max-width: 620px;
  margin: 20px auto;
  box-shadow: 0px 8px 40px rgba(50, 123, 186, 0.16), 0px 4px 4px rgba(50, 123, 186, 0.08);
}
</style>
